
























































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PageLayout from '@/components/page/PageLayout.vue'
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import TaskApi from '@/api/task'
import PartnerApi from '@/api/partner'
import moment from 'moment'
import { TreeSelect } from 'ant-design-vue'
import VisitorRange from './VisitorRange.vue'
import { debounce } from '@/utils/util'
const SHOW_PARENT = (TreeSelect as any).SHOW_PARENT
const debouceFetch = debounce(500)

@Component({
	components: {
		VNodes: {
			functional: true,
			render: (h: any, ctx: any) => ctx.props.vnodes,
		},
		PageLayout,
		VisitorRange,
	},
})
export default class AuditForm extends Vue {
	private addForm: any = {}
	private addLoading: boolean = false
	private phoneId: number = 0
	private hasNoCarNo: boolean = false
	private isInjured: boolean = false
	private searchArea: any = []
	private noData: boolean = false
	private searchHospital: any = []
	private localSearch: any = ''
	private sameWithPublisher: boolean = false
	private areaName: string = ''
	private resurvey: boolean = false
	private SHOW_PARENT: any = SHOW_PARENT
	private visible: boolean = false
	private confirmLoading: boolean = false
	private endOpen: boolean = false
	private checker: any = []
	private fetching: boolean = false
	private selectedVisitor: any = []
	private checkType: any = '1'
	private roleType: any = 'PARTNER'
	private allAreas: any = false
	private allCompany: any = false
	private allVisitor: any = false
	private searchValue: any = ''
	private auditInfoId = ''

	private startTime = ''
	private endTime = ''

	@Prop()
	private info!: any

	@Prop()
	private parentOrderId!: any

	@Prop()
	private isAdd!: string

	private changeTime(val: any, dateStrings: any, type: string) {
		if (type === 'startTime') {
			this.startTime = dateStrings
		} else {
			this.endTime = dateStrings
		}
	}

	private getStartHours() {
		let hours = []
		let time = this.endTime
		let timeArr = time.split(':')
		let timeHour =
			parseInt(timeArr[1]) > 0 ? parseInt(timeArr[0]) + 1 : parseInt(timeArr[0])
		for (var i = timeHour; i < 24; i++) {
			hours.push(i)
		}
		return hours
	}

	private getStartMinutes(selectedHour: any) {
		let time = this.endTime
		let timeArr = time.split(':')
		let minutes = []
		if (selectedHour == parseInt(timeArr[0])) {
			for (var i = parseInt(timeArr[1]); i <= 59; i++) {
				minutes.push(i)
			}
		}
		return minutes
	}

	private getStartSeconds(selectedHour: any, selectedMinute: any) {
		let time = this.endTime
		let timeArr = time.split(':')
		let minutes = []
		if (
			selectedHour == parseInt(timeArr[0]) &&
			selectedMinute == parseInt(timeArr[1])
		) {
			for (var i = parseInt(timeArr[2]); i <= 59; i++) {
				minutes.push(i)
			}
		}
		return minutes
	}

	private getDisabledHours() {
		let hours = []
		let time = this.startTime
		let timeArr = time.split(':')
		for (var i = 0; i < parseInt(timeArr[0]); i++) {
			hours.push(i)
		}
		return hours
	}
	private getDisabledMinutes(selectedHour: any) {
		let time = this.startTime
		let timeArr = time.split(':')
		let minutes = []
		if (selectedHour == parseInt(timeArr[0])) {
			for (var i = 0; i < parseInt(timeArr[1]); i++) {
				minutes.push(i)
			}
		}
		return minutes
	}
	private getDisabledSeconds(selectedHour: any, selectedMinute: any) {
		let time = this.startTime
		let timeArr = time.split(':')
		let second = []
		if (
			selectedHour == parseInt(timeArr[0]) &&
			selectedMinute == parseInt(timeArr[1])
		) {
			for (var i = 0; i <= parseInt(timeArr[2]); i++) {
				second.push(i)
			}
		}
		return second
	}

	// 如果endTime大于startTime 返回true 否则 返回false
	private compareTime(endTime: any, startTime: any) {
		if (this.time_to_sec(startTime) - this.time_to_sec(endTime) > 0) {
			return true
		}
		return false
	}

	//将时分秒转为时间戳
	private time_to_sec(time: any) {
		if (time !== null) {
			let s: any = ''
			var hour = time.split(':')[0]
			var min = time.split(':')[1]
			var sec = time.split(':')[2]
			s = Number(hour * 3600) + Number(min * 60) + Number(sec)
			return s
		}
	}

	private onChooseVisitorOk() {}

	private openVistorModal() {
		this.visible = true
	}

	private onRoleTypeRadioChange(e: any) {
		this.roleType = e.target.value
	}

	private onRadioChange(e: any) {
		this.checkType = e.target.value
		this.allAreas = this.allCompany = this.allVisitor = false
	}

	private onAllAreasChange(e: any) {
		this.allAreas = e.target.checked
		if (this.allAreas) {
			this.addForm.setFieldsValue({
				areaDTOs: {
					label: '全部',
					value: '',
				},
			})
		} else {
			this.addForm.setFieldsValue({
				areaDTOs: undefined,
			})
		}
	}

	private onAllCompanyChange(e: any) {
		this.allCompany = e.target.checked
		if (this.allCompany) {
			this.addForm.setFieldsValue({
				companyIds: {
					label: '全部',
					value: '',
				},
			})
		} else {
			this.addForm.setFieldsValue({
				companyIds: undefined,
			})
		}
	}

	private onAllVisitorChange(e: any) {
		this.allVisitor = e.target.checked
		if (this.allVisitor) {
			this.addForm.setFieldsValue({
				visitors: '全部',
			})
		} else {
			this.addForm.setFieldsValue({
				visitors: undefined,
			})
		}
	}

	private get isUpdate() {
		return this.isAdd === '0'
	}

	private disabledStartDate(startValue: any) {
		const endValue = this.addForm.getFieldValue('endTime')
		const ltToday = startValue.valueOf() < moment().startOf('days')
		if (!startValue || !endValue) {
			return ltToday
		}
		return ltToday || startValue.valueOf() > endValue.valueOf()
	}

	private handleChange(value: any) {
		Object.assign(this as any, {
			value,
			data: [],
			fetching: false,
		})
	}

	private onSearch() {
		this.searchValue = undefined
	}

	private disabledDate(current: any) {
		return current && current < moment().startOf('day')
	}

	private fetchUser(value: string) {
		const id = this.addForm.getFieldValue('partnerId')
		if (!id || !id.value) {
			return
		}
		debouceFetch(() => {
			this.fetching = true
			PartnerApi.getAccountsByCompanyId({
				id: id.value,
				keyword: value,
			})
				.then((res: any) => {
					this.checker = res.data
				})
				.finally(() => {
					this.fetching = false
				})
		})
	}

	private moment() {
		return moment(...arguments)
	}

	private initPage() {
		if (this.isUpdate) {
			const auditInfoId = this.$ss.get('auditInfoId')
			if (this.auditInfoId === auditInfoId) {
				return
			}
			this.auditInfoId = auditInfoId
			this.addForm.resetFields()
			// 构造数据
			PartnerApi.getCheckDetail(auditInfoId).then((res: any) => {
				res.data.checkorsList = []
				res.data.checkors &&
					res.data.checkors.forEach((item: any) => {
						let checkorData = {
							key: item.checkor,
							label: `${item.checkorName} (${item.checkorUserName})`,
						}
						res.data.checkorsList.push(checkorData)
					})
				const data = res.data
				this.checkType = data.checkType
				this.roleType = data.roleType

				this.addForm.setFieldsValue({
					roleType: data.roleType,
				})
				this.$nextTick(() => {
					this.startTime = data.workBeginTime
					this.endTime = data.workEndTime
					this.addForm.setFieldsValue({
						rangeTime: [moment(data.beginTime), moment(data.endTime)],
						workBeginTime: moment(data.workBeginTime, 'HH:mm:ss'),
						workEndTime: moment(data.workEndTime, 'HH:mm:ss'),
						checkType: data.checkType,

						partnerId: {
							value: data.partnerId + '',
							label: data.partnerName,
						},
						// checkor: {
						// 	key: data.checkor + '',
						// 	label: `${data.checkorName} (${data.checkorUserName})`,
						// },
						checkor: data.checkorsList,
					})

					if (data.checkType === '1') {
						// 地区
						if (data.allArea === '1') {
							this.onAllAreasChange({
								target: {
									checked: true,
								},
							})
						} else {
							this.$nextTick(() => {
								this.addForm.setFieldsValue({
									areaDTOs: data.areaSettings.map((item: any) => {
										return {
											value:
												item.areaCode || item.cityCode || item.provinceCode,
											label: item.areaName,
										}
									}),
								})
							})
						}
					} else if (data.checkType === '2') {
						// 保司
						if (data.allCompany === '1') {
							this.onAllCompanyChange({
								target: {
									checked: true,
								},
							})
						} else {
							this.$nextTick(() => {
								this.addForm.setFieldsValue({
									companyIds: data.companySettings.map((item: any) => {
										return {
											value: item.companyId + '',
											label: item.companyName,
										}
									}),
								})
							})
						}
					} else if (data.checkType === '3') {
						// 人员
						if (data.allVisitor === '1') {
							this.onAllVisitorChange({
								target: {
									checked: true,
								},
							})
						} else {
							this.selectedVisitor = data.visitorSettings.map((item: any) => {
								return {
									id: item.visitor,
								}
							})
							this.$nextTick(() => {
								this.addForm.setFieldsValue({
									visitors: data.visitorSettings
										.map((item: any) => {
											return item.visitorName
										})
										.join(','),
								})
							})
						}
					}
				})
			})
		}
	}

	private activated() {
		this.initPage()
	}

	private created() {
		this.addForm = this.$form.createForm(this)
		this.$store.dispatch('setting/initAreas')
		this.$store.dispatch('setting/initCompanyTree')
		this.$store.dispatch('setting/initPartnerTree')
	}

	private onPartnerChange(value: any) {
		this.addForm.setFieldsValue({
			checkor: undefined,
		})
		PartnerApi.getAccountsByCompanyId({
			id: value.value,
		}).then((res: any) => {
			this.checker = res.data
		})
	}

	private onLoadData(treeNode: any) {
		return new Promise(resolve => {
			if (treeNode.dataRef.children) {
				// 有值了直接渲染
				resolve()
				return
			}
			this.$store
				.dispatch('setting/loadAreas', {
					treeNode: treeNode,
					areaCode: treeNode.dataRef.key,
				})
				.then(() => {
					resolve()
				})
		})
	}

	private onChooseOk(selected: any) {
		this.selectedVisitor = selected
		this.addForm.setFieldsValue({
			visitors: selected
				.map((item: any) => {
					return item.name
				})
				.join(','),
		})
	}

	private formatAreas(areas: any) {
		return (
			areas &&
			areas.map((item: any) => {
				if (item.slice(-2) !== '00') {
					return {
						areaCode: item,
					}
				} else if (item.slice(2, 4) !== '00') {
					return {
						cityCode: item,
					}
				} else {
					return {
						provinceCode: item,
					}
				}
			})
		)
	}

	private onTaskAdd(e: any) {
		e.preventDefault()
		if (!this.compareTime(this.startTime, this.endTime)) {
			this.$message.error('时间段开始时间不能大于或等于结束时间')
			return
		}
		this.addForm.validateFields((err: any, values: any) => {
			if (!err) {
				this.addLoading = true
				values = cloneDeep(values)
				values.beginTime = values.rangeTime[0].format('YYYY-MM-DD')
				values.endTime = values.rangeTime[1].format('YYYY-MM-DD')
				delete values.rangeTime

				values.workBeginTime = values.workBeginTime.format('HH:mm:ss')
				values.workEndTime = values.workEndTime.format('HH:mm:ss')
				if (this.allAreas) {
					values.allArea = 1
					delete values.areaDTOs
				} else if (values.areaDTOs) {
					values.areaDTOs = this.formatAreas(
						values.areaDTOs.map((item: any) => {
							return item.value
						})
					)
				}
				if (this.allCompany) {
					values.allCompany = 1
					delete values.companyIds
				} else if (values.companyIds) {
					values.companyIds = values.companyIds.map((item: any) => {
						return item.value
					})
				}
				if (this.allVisitor) {
					values.allVisitor = 1
					delete values.visitors
				} else if (values.visitors) {
					values.visitors = this.selectedVisitor.map((item: any) => {
						return item.id
					})
				}
				let list: any = []
				values.checkor &&
					values.checkor.forEach((item: any) => {
						list.push(item.key)
					})
				values.checkors = list
				// this.roleType === 'PARTNER' && (values.checkor = values.checkor.key)
				this.roleType === 'PARTNER' && values.checkor && values.checkors
				values.partnerId = values.partnerId.value

				if (this.isUpdate) {
					values.id = this.auditInfoId
				}

				PartnerApi.saveCheckRule(values)
					.then((data: any) => {
						this.$message.success(data.message)
						setTimeout(() => {
							this.addLoading = false
							this.onOk()
						}, 600)
					})
					.catch(() => {
						this.addLoading = false
					})
			}
		})
	}

	private onOk() {
		this.addForm.resetFields()
		this.$multiTab.closeCurrentPage()
		this.$multiTab.open('/partner/firstAudit/firstAuditList')
	}
}
